import { z } from 'zod';
import { amountSchema } from './units';

const entryStatisticsSchema = z.object({
  totalDebit: amountSchema,
  totalCredit: amountSchema,
  numDebit: z.number(),
  numCredit: z.number(),
  cumulativeDebits: amountSchema.array(), // Total sum of first 100 debits (since NUM_ENTRIES_WITH_DETAIL_STATISTICS = 100)
  cumulativeCredits: amountSchema.array(), // Total sum of first 100 credits (since NUM_ENTRIES_WITH_DETAIL_STATISTICS = 100)
  cumulativeAmounts: amountSchema.array(), // Total sum of first "n" debits and credits. Merged from debits and credits so n < 200.
});
type EntryStatistics = z.infer<typeof entryStatisticsSchema>;

export { entryStatisticsSchema, type EntryStatistics };
